export default __webpack_public_path__ + "static/media/chevron-right.1838a7d1.svg";